<template>
  <div id="app" dir="ltr">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
export default {
  computed: {
    layout() {
      return "layout-" + (this.$route.meta.layout || "default").toLowerCase();
    },
    
  },
};
</script>
<style></style>
